<template>
  <modal
    name="permit-ivitations-list"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="1070"
    :clickToClose="false"
    @before-open="getData"
    height="auto"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <div class="row align-items-center">
            <div class="col-md-8">
              <div class="form-row align-items-center">
                <div class="col-sm-6 mb-2 mb-sm-0">
                  <!-- <p class="text-white txt--ss opacity--50">
                    Permit Invitations
                  </p> -->
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                      <li 
                      :class="[mode=='' ? 'active' : '']"
                      @click="changeTab('')"
                      >Available</li>
                      <li
                      :class="[mode=='expired' ? 'active' : '']"
                      @click="changeTab('expired')"                  
                      >Expired </li>
                      <li
                      :class="[mode=='deleted' ? 'active' : '']"
                      @click="changeTab('deleted')"
                      >Deleted </li>                      
                    </ul>
                  </div>
                </div>
                <div class="col-sm-6 mb-2 mb-sm-0">
                  <div class="search-field">
                    <input
                      type="text"
                      placeholder="Search Invitations & Emails"
                      class="textInputField"
                      v-model="search"
                    />
                    <button
                      type="button"
                      @click="crossButton()"
                      class="clear-search-button"
                      title="Clear value of search filed"
                      v-show="search !== ''"
                    >
                      x
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-row align-items-end">
                <div class="col-sm-6 mb-2 mb-sm-0 d-none">
                  <div
                    class="filter__dropdown"
                    @mouseover="showByDropdown = true"
                    @click.stop="showByDropdown = true"
                  >
                    <p class="txt--off-white txt--ss">
                      Filter by: <span class="ml-2 opacity--25">Status</span>
                    </p>

                    <div
                      class="filter__items"
                      style="z-index: 4"
                      v-show="showByDropdown"
                      @mouseleave="showByDropdown = false"
                      v-click-outside="closeDropdown"
                    >
                      <div class="px-3 mt-3">
                        <div class="top__filter">
                          <ul class="top__filter__ul">
                            <li>Status</li>
                          </ul>
                        </div>
                        <p
                          class="
                            txt--primary txt--ss
                            my-1
                            txt--semi-bold
                            cursor-pointer
                          "
                        >
                          Sent
                        </p>
                        <p
                          class="
                            txt--primary txt--ss
                            my-1
                            txt--semi-bold
                            cursor-pointer
                          "
                        >
                          Complete
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <p
                    v-if="user_role == 'commercial' || (user_role == 'operator' && access_lists.invitation_access_write == true)"
                    class="txt--off-white txt--ss text-sm-right cursor-pointer"
                    @click="tiggerSendApplication"
                  >
                    Send Invitations
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content__divider"></div>

        <div class="reports__propeties">
          <div class="reports__stats-header">
            <div class="row">
              <div class="col">
                <p class="txt--primary txt--xs txt--semi-bold">
                  Group <i class="ml-1 fas fa-angle-down"></i>
                </p>
              </div>
              <div class="col">
                <p class="txt--xs txt--semi-bold opacity--50">Starts At</p>
              </div>
              <div class="col">
                <p class="txt--xs txt--semi-bold opacity--50">Properties</p>
              </div>
              <div class="col">
                <p class="txt--xs txt--semi-bold opacity--50">Choices</p>
              </div>
              <div class="col">
                <p class="txt--xs txt--semi-bold opacity--50" v-if="mode==''">Expires</p>
                <p class="txt--xs txt--semi-bold opacity--50" v-else>Expired</p>
              </div>
              <!-- <div class="col" v-if="access_lists.invitation_access_write"> -->
              <div class="col"
                v-if="user_role == 'commercial' || (user_role == 'operator' && access_lists.invitation_access_write == true)"
              >
                <p v-if="mode==''" class="txt--xs txt--semi-bold opacity--50">Action</p>
              </div>
              <div class="col">
                <p v-if="mode==''" class="txt--xs txt--semi-bold opacity--50">Export</p>
              </div>
            </div>
          </div>
          <div class="reports__stats-body" v-if="invitationLists.length > 0">
            <div
              :class="[
                'reports__item',
                show_invitation_email == index && show_status == true
                  ? 'sticky-open'
                  : '',
              ]"
              v-for="(invitation, index) in invitationLists"
              :key="index"
            >
              <!-- Invitation List -->
              <div class="row reports__padding">
                <div class="col">
                  <p
                    class="txt--primary property__header__text cursor-pointer"
                    @click="getAllEmailsByInvitationId(invitation.id, index)"
                  >
                    {{
                      invitation.invitation_name != ""
                        ? invitation.invitation_name
                        : "Not Proided!"
                    }}
                  </p>
                </div>
                <div class="col">
                  <p
                    class="property__header__text cursor-pointer"
                    @click="getAllEmailsByInvitationId(invitation.id, index)"
                  >
                    {{ formatDate(invitation.start_date) }}
                  </p>
                </div>
                <div class="col">
                  <p
                    class="property__header__text cursor-pointer"
                    @click="getAllEmailsByInvitationId(invitation.id, index)"
                  >
                    {{
                      invitation.properties.length != ""
                        ? invitation.properties.length
                        : 0
                    }}
                  </p>
                </div>
                <div class="col">
                  <p
                    class="property__header__text cursor-pointer"
                    @click="getAllEmailsByInvitationId(invitation.id, index)"
                  >
                    {{
                      invitation.available_selections != ""
                        ? invitation.available_selections
                        : 0
                    }}
                  </p>
                </div>
                <div class="col">
                  <p
                    class="property__header__text cursor-pointer"
                    @click="getAllEmailsByInvitationId(invitation.id, index)"
                  >
                    {{
                      invitation.expiration_date != "" &&
                      invitation.expiration_date != null
                        ? formatDate(invitation.expiration_date)
                        : "N/A"
                    }}
                  </p>
                </div>
                <!-- <div class="col" v-if="access_lists.invitation_access_write"> -->
                <div class="col"
                v-if="user_role == 'commercial' || (user_role == 'operator' && access_lists.invitation_access_write == true)"
                >
                  <p
                    v-if="mode==''"
                    class="property__header__text cursor-pointer"
                    @click="editInvitation(invitation)"
                  >
                    Edit
                  </p>
                  <p
                    v-if="mode==''"
                    class="property__header__text cursor-pointer"
                    @click="deleteInvitation(invitation)"
                  >
                    Delete
                  </p>
                </div>
                <div class="col ">
                  <p class="property__header__text cursor-pointer"
                     v-if="mode==''"
                     @click="getCsv(invitation)"
                  >
                    Export
                  </p>
                </div>
              </div>

              <!-- Invitation User List -->
              <div
                class="reports__item__content"
                v-if="show_invitation_email == index && show_status == true"
              >
                <div class="content__divider"></div>
                <div class="reports__details" style="height: 160px">
                  <div class="row flex-nowrap pt-2 report-inner-header pb-2">
                    <div class="col-2">
                      <p class="txt--primary txt--xs txt--semi-bold">
                        Email Address <i class="ml-1 fas fa-angle-down"></i>
                      </p>
                    </div>
                    <div class="col-1">
                      <p class="txt--xs txt--semi-bold opacity--50">Claimed</p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        Date Sent
                      </p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        Date Replied
                      </p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        Date Completed
                      </p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">Status</p>
                    </div>
                    <!-- <div class="col-1" v-if="access_lists.invitation_access_write"> -->
                    <div class="col-1"
                    v-if="user_role == 'commercial' || (user_role == 'operator' && access_lists.invitation_access_write == true)"
                    >
                      <p v-if="mode==''" class="txt--xs txt--semi-bold opacity--50">Action</p>
                    </div>
                  </div>

                  <div
                    class="reports__details--body"
                    v-if="invitationEmailLists.length > 0"
                  >
                    <div v-show="percentLoader" class="reportSpinner"></div>

                    <div
                      class="row flex-nowrap pt-2"
                      v-for="(
                        invitation_emails, index_2
                      ) in invitationEmailLists"
                      :key="index_2"
                    >
                      <div class="col-2">
                        <p
                          class="txt--primary txt--xs txt--semi-bold text-break"
                        >
                          {{
                            invitation_emails.email != ""
                              ? invitation_emails.email
                              : "N/A"
                          }}
                        </p>
                      </div>
                      <div class="col-1">
                        <p
                          class="
                            txt--xs txt--semi-bold txt--off-white
                            cursor-pointer
                          "
                        >
                          {{ invitation_emails.claimed == 1 ? "Yes" : "No" }}
                        </p>
                      </div>
                      <div class="col-2">
                        <p class="txt--xs txt--semi-bold txt--off-white">
                          {{
                            invitation_send_date != ""
                              ? formatDate(invitation_send_date)
                              : "N/A"
                          }}
                        </p>
                      </div>
                      <div class="col-2">
                        <p class="txt--xs txt--semi-bold txt--off-white">
                          {{
                            invitation_emails.replied_at != "" &&
                            invitation_emails.replied_at != null
                              ? formatDate(invitation_emails.replied_at)
                              : "N/A"
                          }}
                        </p>
                      </div>
                      <div class="col-2">
                        <p class="txt--xs txt--semi-bold txt--off-white">
                          {{
                            invitation_emails.date_completed != "" &&
                            invitation_emails.date_completed != null
                              ? formatDate(invitation_emails.date_completed)
                              : "N/A"
                          }}
                        </p>
                      </div>
                      <div class="col-2"> 
                        <p v-if="mode==''"
                          class="
                            txt--xs txt--semi-bold txt--off-white
                            cursor-pointer
                          "
                          @click="
                            openInvitationDetailsModal(
                              invitation_emails,
                              invitation_send_date,
                              invitation_expiry_date,
                              invitation.id
                            )
                          "
                        >
                          {{
                            invitation_emails.status != ""
                              ? invitation_emails.status[0].toUpperCase() +
                                invitation_emails.status.slice(1)
                              : "N/A"
                          }}
                        </p>
                        <p v-else 
                          class="
                            txt--xs txt--semi-bold txt--off-white
                            cursor-pointer
                          "
                        >
                          {{
                            invitation_emails.status != ""
                              ? invitation_emails.status[0].toUpperCase() +
                                invitation_emails.status.slice(1)
                              : "N/A"
                          }}
                        </p>
                      </div>
                      <!-- <div
                        class="col-1"
                        v-if="invitation_emails.status != 'completed'  && access_lists.invitation_access_write"
                      > -->
                        <!-- v-if="invitation_emails.status != 'completed'" -->
                      <div
                        class="col-1"
                        v-if="invitation_emails.status != 'completed' && (user_role == 'commercial' || (user_role == 'operator' && access_lists.invitation_access_write == true))"
                      >
                        <p v-if="mode==''"
                          class="
                            txt--xs txt--semi-bold txt--off-white
                            cursor-pointer
                          "
                          @click="
                            resendInvitation(
                              invitation.id,
                              invitation_emails.email,
                              invitation_emails.status
                            )
                          "
                        >
                          Resend
                        </p>
                      </div>
                      <div class="col-1" v-else-if="user_role == 'commercial' || (user_role == 'operator' && access_lists.invitation_access_write == true)">
                        <p v-if="mode==''"
                          class="
                            txt--xs txt--semi-bold txt--off-white
                            cursor-pointer
                          "
                        >
                          N/A
                        </p>
                      </div>
                    </div>

                    <p v-if="mode=='' && (user_role == 'commercial' || (user_role == 'operator' && access_lists.invitation_access_write == true))"
                      class="txt--xss opacity--25 txt--fsxs cursor-pointer mt-2"
                      @click="showInviteMore(invitation.id, invitation.invitation_name)"
                    >
                      + Invite more
                    </p>
                  </div>

                  <div class="reports__details--body" v-else>
                    <div class="row flex-nowrap pt-2">
                      <div class="col 12">
                        <p
                          class="
                            txt--primary txt--xs txt--semi-bold
                            text-center
                          "
                        >
                          No Data Found!
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- Invitation User List Pagination Call -->
                  <infinite-loading
                    @infinite="getEmailsByInvitationIdPagination"
                    :distance="10"
                    :identifier="invitationEmail_infiniteId"
                      v-if="
                      show_invitation_email == index &&
                      show_status == true &&
                      email_invitation_loadMore
                    "
                  >
                    <div slot="spinner">
                      <div class="d-flex justify-content-center mt-4">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div slot="no-more"></div>
                    <div slot="no-results">No data found</div>
                  </infinite-loading>
                </div>
                <div class="content__divider"></div>
              </div>
            </div>
          </div>
          <div class="reports__stats-body" v-else>
            <div class="row flex-nowrap pt-2">
              <div class="col-12">
                <p class="txt--primary txt--xs txt--semi-bold text-center">
                  No Data Found!
                </p>
              </div>
            </div>
          </div>

          <!-- Parent Invitation List Infine Scolling -->
          <infinite-loading
            @infinite="getInvitationList"
            :distance="10"
            :identifier="invitation_infiniteId"
          >
            <div slot="spinner">
              <div class="d-flex justify-content-center mt-4">
                <div class="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
            <div slot="no-more"></div>
            <div slot="no-results">No data found</div>
          </infinite-loading>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>

    <SendPermitInvitation
      @update_invitation_list="resetData"
    ></SendPermitInvitation>
    <PermitInvitationDetails @update_invitation_list="resetData" />
    <EditInvitation @update_invitation_list="resetData" />
    <InviteMorePermit @update_invitation_list="resetData"/>
  </modal>
</template>

<script>
import SendPermitInvitation from "@/components/modals/SendPermitInvitation";
import InviteMorePermit from "@/components/modals/InviteMorePermit";
import PermitInvitationDetails from "@/components/modals/PermitInvitationDetails.vue";
import EditInvitation from "@/components/modals/EditPermitInvitation";
export default {
  name: "Permit-Invitations",
  props:['access_lists'],
  components: {
    SendPermitInvitation,
    PermitInvitationDetails,
    EditInvitation,
    InviteMorePermit,
  },
  data() {
    return {
      search: "",
      showByDropdown: false,
      invitationLists: [],
      invitation_id: "",
      invitationEmailLists: [],
      percentLoader: false,
      show_invitation_email: -1,
      invitation_source: null,
      invitation_user_list_source: null,
      show_status: false,
      invitation_send_date: "",
      invitation_expiry_date: "",
      //infinite scoll pagination variables
      invitation_infiniteId: +new Date(),
      invitationEmail_infiniteId: +new Date(),
      invitation_parent_page: 1,
      invitation_email_page: 1,
      parent_invitation_loadMore: true,
      email_invitation_loadMore: true,
      deleted:false,
      expired:false,
      mode:'',
      user_role:    '',
      access_list:  {},
    };
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        console.log(binding);
      },
    },
  },
  created() {
    this.user_role    = localStorage.getItem("role");
    this.access_list  = JSON.parse(localStorage.getItem("commercial_access_list"));
    // Invitation List Is Called Via Infinite Loader On Modal Open
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.invitationLists = [];
        this.invitationEmailLists = [];
        this.percentLoader = false;
        this.show_invitation_email = -1;
        this.show_status = false;
        this.invitation_send_date = "";
        this.invitation_expiry_date = "";
        this.invitation_parent_page = 1;
        this.invitation_email_page = 1;
        this.parent_invitation_loadMore = true;
        this.email_invitation_loadMore = true;
        this.invitation_infiniteId++;
        // this.getInvitationList();
      }
    },
  },
  methods: {
    getData(e) {
      this.search = "";
      this.showByDropdown = false;
      this.invitationLists = [];
      this.invitation_id = "";
      this.invitationEmailLists = [];
      this.percentLoader = false;
      this.show_invitation_email = -1;
      this.invitation_source = null;
      this.invitation_user_list_source = null;
      this.show_status = false;
      this.invitation_send_date = "";
      this.invitation_expiry_date = "";
      //infinite scoll pagination variables
      this.invitation_infiniteId = +new Date();
      this.invitationEmail_infiniteId = +new Date();
      this.invitation_parent_page = 1;
      this.invitation_email_page = 1;
      this.parent_invitation_loadMore = true;
      this.email_invitation_loadMore = true;
    },
    formatDate(date) {
      if (date) {
        return this.$moment(date).format("lll");
      } else {
        return "N/A";
      }
    },
    closeDropdown() {
      this.showByDropdown = false;
    },
    crossButton() {
      this.search = "";
    },
    closeModal() {
      this.$modal.hide("permit-ivitations-list");
    },
    openModal(modalName) {
      this.$modal.show(modalName);
    },
    openInvitationDetailsModal(
      invitation_users,
      invitation_send_date,
      invitation_expiry_date,
      invitation_id
    ) {
      invitation_users.invitation_created_at = invitation_send_date;
      invitation_users.expiration_date = invitation_expiry_date;
      invitation_users.invitation_id = invitation_id;
      this.$modal.show("permit-invitation-details", {
        invitation_users: JSON.parse(JSON.stringify(invitation_users)),
        invitation_id: this.invitation_id,
      });
    },
    tiggerSendApplication() {
      this.$emit("send-application", true);
    },
    resetData() {
      this.showByDropdown = false;
      this.invitationLists = [];
      this.invitation_id = "";
      this.invitationEmailLists = [];
      this.percentLoader = false;
      this.show_invitation_email = -1;
      this.session_chart_source = null;
      this.show_status = false;
      this.invitation_send_date = "";
      this.invitation_expiry_date = "";
      this.invitation_parent_page = 1;
      this.invitation_email_page = 1;
      this.parent_invitation_loadMore = true;
      this.email_invitation_loadMore = true;
      this.invitation_infiniteId = this.invitation_infiniteId + 1;
      this.invitationEmail_infiniteId = this.invitationEmail_infiniteId + 1;
    },
    getInvitationList($state) {
      if (this.invitation_source) {
        this.invitation_source.cancel("Cancel previous request");
      }

      const CancelToken = this.axios.CancelToken;
      this.invitation_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/invitation/list",
          {
            mode:this.mode,
            device_type: 1,
            limit: 10,
            page: this.invitation_parent_page,
            search: this.search,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.invitation_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            if (res.data.data.invitations) {
              let invitation_data = res.data.data.invitations;
              invitation_data.map((data) => {
                this.invitationLists.push(data);
              });

              this.parent_invitation_loadMore =
                res.data.data.pagination.load_more == 1 ? true : false;
              this.invitation_parent_page = res.data.data.pagination.page;
              $state.loaded();
              if (!this.parent_invitation_loadMore) {
                $state.complete();
              }
            } else {
              this.invitationLists = [];
              this.invitation_parent_page = 1;
              this.parent_invitation_loadMore = false;
              $state.complete();
            }
          } else {
            this.invitationLists = [];
            this.invitation_parent_page = 1;
            this.parent_invitation_loadMore = false;
            $state.complete();
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            return;
          }
          console.log(err);
        });
    },
    getAllEmailsByInvitationId(invitation_id, index) {
      this.email_invitation_loadMore = true;
      this.invitation_id = "";
      this.invitation_email_page = 1;

      if (this.show_invitation_email == index) {
        this.show_invitation_email = -1;
        this.show_status = false;
        return;
      }

      this.show_status = false;
      this.percentLoader = true;
      this.$Progress.start();
      if (this.invitation_user_list_source) {
        this.invitation_user_list_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.invitation_user_list_source = CancelToken.source();
      this.axios
        .post(
          window.hostname + "/api/auth/invitation/user-details",
          {
            mode:this.mode,
            device_type: 1,
            limit: 1000,
            page: this.invitation_email_page,
            invitation_id: invitation_id,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.invitation_user_list_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            // this.invitationEmailLists = res.data.data.user_list;

            let invitationRepliedCompletedList = res.data.data.user_list
              .filter((value) => value.status != "sent")
              .sort((a, b) => new Date(b.replied_at) - new Date(a.replied_at));
            let invitationSentList = res.data.data.user_list.filter(
              (value) => value.status == "sent"
            );

            this.invitationEmailLists =
              invitationRepliedCompletedList.concat(invitationSentList);

            this.invitation_send_date = res.data.data.invitation_created_at;
            this.invitation_expiry_date = res.data.data.expiration_date;
            this.invitation_id = invitation_id;
            this.show_invitation_email = index;
            this.show_status = true;
            this.invitation_email_page++;

            this.email_invitation_loadMore =
              res.data.data &&
              res.data.data.pagination &&
              res.data.data.pagination.load_more == 1
                ? true
                : false;
            this.$Progress.finish();
          } else {
            this.invitationEmailLists = [];
          }
          this.percentLoader = false;
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            return;
          }
          this.$Progress.fail();
          this.percentLoader = false;
        });
    },
    getEmailsByInvitationIdPagination($state) {
      if (this.invitation_user_list_source) {
        this.invitation_user_list_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.invitation_user_list_source = CancelToken.source();
      this.axios
        .post(
          window.hostname + "/api/auth/invitation/user-details",
          {
            device_type: 1,
            limit: 1000,
            page: this.invitation_email_page,
            invitation_id: this.invitation_id,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.invitation_user_list_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            let invitationEmailLists =
              res.data.data && res.data.data.user_list
                ? res.data.data.user_list
                : [];

            if (invitationEmailLists.length > 0) {
              invitationEmailLists.map((val) => {
                this.invitationEmailLists.push(val);
              });

              let invitationRepliedCompletedList = this.invitationEmailLists
                .filter((value) => value.status != "sent")
                .sort(
                  (a, b) => new Date(b.replied_at) - new Date(a.replied_at)
                );
              let invitationSentList = this.invitationEmailLists.filter(
                (value) => value.status == "sent"
              );

              this.invitationEmailLists =
                invitationRepliedCompletedList.concat(invitationSentList);

              this.invitation_email_page++;
              $state.loaded();
            } else {
              this.email_invitation_loadMore = false;
              $state.complete();
            }
            this.$Progress.finish();
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            return;
          }
          this.$Progress.fail();
          $state.error();
        });
    },
    editInvitation(invitation) {
      this.invitation_id = invitation.id;

      this.$modal.show("edit-permit-ivitation", {
        invitation: invitation,
      });
    },
    resendInvitation(invitation_id, email, status) {
      let message = "";
      if (status == "sent") {
        message =
          "Do you want to send an invitaton link? Invitation link will be sent to the first invited email.";
      } else if (status == "replied") {
        message =
          "This user has already replied in this invitation! Sending another invitation link will remove their previous selections. Invitation link will be sent to the first invited email. Do you want to proceed?";
      } else {
        message = "Do you want to send an invitaton link to this email?";
      }

      this.$swal({
        title: "Are you sure?",
        text: message,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "/api/auth/invitation/resend", {
              invitation_id: invitation_id,
              email: email,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show("Invitation sent successfully!", {
                  icon: "check-circle",
                  className: "success-class",
                });
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
              }
            })
            .catch((err) => {
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });
    },
    showInviteMore(invitation_id, invitation_name) {
      this.$modal.show("invite-more-permit-modal",{
        invitation_id: invitation_id,
        invitation_name: invitation_name
      });
    },
    deleteInvitation(invitation){
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this invitation",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "/api/auth/invitation/delete", {
             invitation_id:invitation.id
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
             this.resetData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    changeTab(status){
      console.log(status);
      this.mode = status;
      this.invitation_infiniteId =+new Date();
      this.resetData();
    },
    getCsv(invitation){
      this.$Progress.start();
      this.percentLoader = true;
      this.axios
        .post(window.hostname + "/api/auth/invitation/export-invitation", {
            invitation_id:invitation.id
        }).then((res)=>{
            if (res.data.status){
               console.log(res.data);
                let csv_donload_link = res.data.data;
                // let file_name = res.data.data.file_name ;
                var element = document.createElement("a");
                element.href = csv_donload_link;
                element.setAttribute("download", "Permitinvitation.csv");

                element.style.display = "none";
                document.body.appendChild(element);

                element.click();

                document.body.removeChild(element);
                this.$toasted.show("Your file download has started!", {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.$Progress.finish();
                this.percentLoader = false;
            }
            else{
                this.$Progress.fail();
                this.percentLoader = false;
                this.$toasted.show(
                  "File download failed. Please try again later!",
                  {
                    icon: "times-circle",
                    className: "error-class",
                  }
                );
            }

        })
        .catch((err) => {
            console.log(err.response.data.message);
            this.$Progress.fail();
            this.percentLoader = false;
            this.$toasted.show("File download failed. Please try again later!", {
              icon: "times-circle",
              className: "error-class",
            });
        });
    },

  },
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
.reports__item.sticky-open {
  top: 33px !important;
}
</style>

